import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="font-accent text-xs tracking-[0.35em] uppercase text-[#8B5CF6] flex items-center gap-3">
    <span className="inline-block h-px w-8 bg-[#8B5CF6]" aria-hidden="true" />
    {children}
  </p>
);
